import { AllowedAttachmentSources } from '~/__generated__/globalTypes'

export const QUALITY_DEFAULT_PAGE = 1

export const JOB_REQUEST_STATE = {
    SENT: 'sent',
    VIEWED: 'viewed',
    COMPLETED: 'completed',
    EXPIRED: 'expired',
    REJECTED: 'rejected',
    CANCELLED: 'canceled',
    ACCEPTED: 'accepted',
} as const

export const PROCESS_TYPES_MAP = {
    CNC: 'cnc',
    TDP: '3dp',
}

export const PRODUCTION_STAGE = {
    PRODUCTION: 'production',
    POST_PROCESS: 'post_processing',
    FICTIV5: 'fictiv5',
} as const

export const JOB_REQUEST_STATUS_FOR_LIST = Object.freeze({
    [JOB_REQUEST_STATE.ACCEPTED]: 'Job incomplete',
    [JOB_REQUEST_STATE.COMPLETED]: 'Job completed',
})

export const JOB_REQUEST_INSPECTION_STATE = {
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    NOT_STARTED: 'not_started',
} as const

export const JOB_REQUEST_INSPECTION_LABELS = {
    [JOB_REQUEST_INSPECTION_STATE.PENDING]: 'Not started',
    [JOB_REQUEST_INSPECTION_STATE.IN_PROGRESS]: 'In progress',
    [JOB_REQUEST_INSPECTION_STATE.COMPLETED]: 'Completed',
} as const

export const DATE_FORMAT = 'dddd, L'
export const DATE_TIME_FORMAT = 'dddd, L h:mm a'
export const SHORT_DATE_TIME_FORMAT = 'L h:mm a'

export const STATUS_COLORS = {
    [JOB_REQUEST_STATE.COMPLETED]: 'green',
    [JOB_REQUEST_STATE.SENT]: 'magenta',
    [JOB_REQUEST_STATE.VIEWED]: 'magenta',
    [JOB_REQUEST_STATE.REJECTED]: 'orange',
    [JOB_REQUEST_STATE.EXPIRED]: 'orange',
    [JOB_REQUEST_STATE.CANCELLED]: 'orange',
    [JOB_REQUEST_STATE.ACCEPTED]: 'orange',
    [PRODUCTION_STAGE.PRODUCTION]: 'magenta',
    [PRODUCTION_STAGE.POST_PROCESS]: 'magenta',
    [PRODUCTION_STAGE.FICTIV5]: 'green',
    DEFAULT_COLOR: 'blue',
}

export const ALLOWED_ATTACHMENT_SOURCE_TYPE = {
    MP: 'MP' as AllowedAttachmentSources,
    QC: 'QC' as AllowedAttachmentSources,
    FICTIV: 'FICTIV' as AllowedAttachmentSources,
}

export const HQ_UPLOAD_STATUS = {
    AVAILABLE: 'Available',
    NOT_AVAILABLE: 'Not Available',
} as const

export const UPLOADED_ATTACHMENT_FILE_TYPE = {
    IMAGE_TYPE: 'image',
    FILE_TYPE: 'application',
}
